export default "/images/c45125303d798eb451c2e8974d18f997.avif";